export default __webpack_public_path__ + "navigation-examples-beta-query-parameters-960-f466dfb36a00fafb63e4709d540ee25b.webp";